import { InitClient,GetByParas,Post,PostWithParas,PostNoParas} from "../ZeusAPIClient.js"
import { apiConfig } from "../../config.js"
import { PagingBody } from "../Model/PagingBody"

InitClient(apiConfig.clientId,apiConfig.clientSecret,apiConfig.host);
//获取所有节点
function GetNodeAllList(){
    var paras={};
    return GetByParas('15fbd13a-0805-4a6d-9aa3-3e7b48534dce',paras);
}
//获取节点及文章
function GetNodeAndArticle(){
    var data={};
    return PostWithParas('4bd66be4-7d8f-48a7-bc32-62c3d224f108','',data);
}
//获取标签一二级信息
function GetNodeFirstAndSecond(){
    var data={};
    return PostWithParas('ab907c29-0420-4cb6-a4ae-b291f3c00c87','',data);
}
//获取标签和文章树状结构信息
function GetWikiNodeAndArticle(){
    var data={};
    return PostWithParas('6917a125-c605-401d-b2c0-686819a80d82','',data);
}
//获取标签树状结构信息
function GetWikiNode(){
    var data={};
    return PostWithParas('9d83f69c-2ccd-4b10-b5a8-fd1b65f2f0be','',data);
}
//根据条件获取节点列表
function GetNodeListByWhere(predicates){
    return PostWithParas('4bd66be4-7d8f-48a7-bc32-62c3d224f108','',predicates);//Post('f6a0c578-26e3-416a-a2a4-00ea1a94529f',predicates);
}
//添加节点
async function InsertNode(node){
    var data=await PostWithParas('c193adb5-2f81-44c4-8709-8b1ba5507fbd','',node)
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//更新节点
async function UpdateNode(nodeid,node){
    var paras={
        ID:nodeid
    }
    var data=await PostWithParas('124e7806-0d3e-4196-b15c-d3e69a54557c',paras,node);
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//根据ID获取单个节点
function GetSingleNode(nodeId){
    var paras={
        ID:nodeId
    };
    return GetByParas('15fbd13a-0805-4a6d-9aa3-3e7b48534dce',paras);
}
//根据节点Id获取子节点列表
function GetChildrenNodesId(nodeId){
    var paras={
        id:nodeId
    };
    return GetByParas('dedab341-3114-4b96-abf4-1ffa46428cca',paras); 
}
//根据节点Id获取子节点列表信息
function GetChildrenNodesIds(nodeId){
    var data={
        id:nodeId
    };
    //return PostWithParas();//GetByParas('ec80e8c9-96a7-48e4-be3e-fec3d71bcdd5',paras); 
    return PostWithParas('ec80e8c9-96a7-48e4-be3e-fec3d71bcdd5','',data); 
}
//获取所有节点和百科列表
function GetNodeAndKnowledgeList(){
    var paras={};
    return GetByParas('15fbd13a-0805-4a6d-9aa3-3e7b48534dce',paras);
}
//根据ID获取一个百科
function GetSingleKnowledge(kId){
    var paras={
        ID:kId
    };
    return GetByParas('b5385c79-c121-4bcf-b771-84cfa998402f',paras);
}
//根据ID获取一个百科影子
function GetSingleKnowledgeShadow(kId){
    var paras={
        ID:kId
    };
    return GetByParas('adebd333-c502-4604-9c70-bf8748cc44a7',paras);
}
//插入一个百科
function InsertKnowledge(knowledge){
    var data=Post('af486492-02ed-4097-a41f-917e2c297b29',knowledge)
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//更新节点
function UpdateKnowledgew(kId,knowledge){
    var paras={
        ID:kId
    }
    var data=PostWithParas('124e7806-0d3e-4196-b15c-d3e69a54557c',paras,knowledge)
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//更新百科影子
async function UpdateKnowledgewShadow(kId,knowledgeShadow){
    var paras={
        ID:kId
    }
    var data=await PostWithParas('b40f1d80-00c0-4d52-85d8-7ac62662cda6',paras,knowledgeShadow)
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//更新百科影子并影响百科
async function UpdateKnowledgewAndShadow(kId,knowledgeShadow){
    var paras={
        ID:kId
    }
    var data=await PostWithParas('d53cdd97-2c2c-4b84-bb61-67eebaab0235',paras,knowledgeShadow)
    data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//删除节点文章
async function DeleteKnowledge(kId,knowledge){
    var paras={
        ID:kId
    }
    var data=await PostWithParas('ab033dc7-d533-4065-bc82-9f7dfece9876',paras,knowledge);
    // data=data.replace("\"", "");
    if(data=='success'){
        return true;
    }
    else{
        return false;
    }
}
//获取百科分页列表
function GetKnowledgePage(predicates,pageIndex,pageSize,orderBy,sort){
    var pb=new PagingBody(predicates,pageIndex,pageSize,orderBy,sort);
    return Post('ba413769-3a22-47ee-bcf4-9ecb63d7a65a',pb);
}
//获取待审核分页列表 
function GetKnowledgeAuditPage(predicates,pageIndex,pageSize,orderBy,sort){
    var paras={};
    var data={
        OrderBy:orderBy,
        Sort:sort,
        PageIndex:pageIndex,
        PageSize:pageSize,
        Predicates:predicates
    };
    return PostWithParas('4406e809-c77e-4f76-ac06-87bf80813324',paras,data);
}
//获取热门列表 
async function GetHotKnowledgeList(count){
    var data = {
        top:count
    };
    return await GetByParas('84ee2a00-2aca-489c-b949-cfbf64d9caa1',data);
}
//获取热门搜索列表
async function GetHotSearchKnowledgeList(tag){
    var data = {
        tag:tag
    };
    return await GetByParas('b1e97d98-3927-4f9c-9dd9-06fa126577c8',data);
}
//文章内容解密接口
function GetKnowledgeContentDescry(content){
    var paras={};
    return PostWithParas('46e63bce-5d40-47b3-8423-4b6dadd7ebe1',paras,content);
}
//文章内容加密接口
function EncryptContent(content)
{
    return Post('f8d6fe22-0c1a-449b-9b5e-1a1eae928488',content);
}
//获取销售锦囊页树状结构
async function GetTreeBySales(id,type){
    var data={
        id:id,
        type:type
    };
    return await GetByParas('fa5bc8a2-adca-40c7-83bb-fd0cc11d128d',data);
}
//将方法暴露出去
export{
    GetNodeAllList,
    GetNodeListByWhere,
    GetNodeAndArticle,
    GetWikiNodeAndArticle,
    GetWikiNode,
    GetNodeFirstAndSecond,
    InsertNode,
    UpdateNode,
    GetSingleNode,
    GetChildrenNodesId,
    GetChildrenNodesIds,
    GetNodeAndKnowledgeList,
    GetSingleKnowledge,
    InsertKnowledge,
    UpdateKnowledgew,
    DeleteKnowledge,
    GetKnowledgePage,
    GetKnowledgeAuditPage,
    GetKnowledgeContentDescry,
    GetSingleKnowledgeShadow,
    UpdateKnowledgewAndShadow,
    UpdateKnowledgewShadow,
    EncryptContent,
    GetTreeBySales,
    GetHotKnowledgeList,
    GetHotSearchKnowledgeList,
}